import { produce } from 'immer';
import { SelectedContractAction } from '../../actions/SelectedContract';

type NoContractSelected = {
  status: 'NoContractSelected'
};

type ContractSelected = {
  status: 'ContractSelected',
  contractId: string,
  id: string,
};

export type SelectedContractState = NoContractSelected | ContractSelected;

const initialState: SelectedContractState = {
  status: 'NoContractSelected',
} as const;

const selectedContract = produce((draft: SelectedContractState, action: SelectedContractAction): SelectedContractState => {
  switch (action.type) {
    case 'CONTRACT_SELECTED': {
      return {
        status: 'ContractSelected',
        contractId: action.payload.contractId,
        id: action.payload.id,
      };
    }
    case 'CONTRACT_RESET': {
      return {
        status: 'NoContractSelected',
      };
    }
    default: {
      return draft;
    }
  }
}, initialState as SelectedContractState);

export default selectedContract;
